import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  CreateButton,
  TopToolbar,
  useRedirect,
} from 'react-admin';
import { AccountTree as WorkflowIcon } from '@mui/icons-material';
import { PageTitle } from '../../components/PageTitle';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export const WorkflowList = () => {
  const redirect = useRedirect();

  const handleCreateWorkflow = () => {
    redirect('/workflows/create');
  };

  return (
    <>
      <PageTitle title="Workflows" titleKey="pages.workflows" icon={<WorkflowIcon />} />
      <List
        actions={<ListActions />}
        empty={<CustomEmptyState resource="workflows" onAction={handleCreateWorkflow} />}
        sort={{ field: 'name', order: 'ASC' }}
        perPage={25}
      >
        <Datagrid
          bulkActionButtons={false}
          rowClick="edit"
        >
          <TextField source="name" label="Name" />
          <TextField source="description" label="Description" />
          <BooleanField source="isActive" label="Active" />
        </Datagrid>
      </List>
    </>
  );
};